import React from "react";

// order_items.quantity is numeric(10,3) now (fractional for kg/gr
// products), so trim the trailing ".000" for whole-unit quantities.
const formatQuantity = (value) => {
    const n = parseFloat(value);
    if (isNaN(n)) return value;
    return n % 1 === 0 ? n.toString() : n.toFixed(3).replace(/0+$/, "").replace(/\.$/, "");
};

export default function PrintPage({ order }) {
    if (!order) return <p className="text-center my-3">Ýüklenýär...</p>;

    return (
        <div className="print-only">
            <div className="container-fluid my-4 print-content">
                <div className="d-flex justify-content-end fw-semibold">
                    <p>Haryt nomeri: {order.id}</p>
                </div>
                <div className="row mb-3">
                    <div className="d-flex gap-2">
                        <div className="col-6 d-flex justify-content-between">
                            <p><strong>Telefon belgisi:</strong> </p>
                            <p>{order.phone_number || 'N/A'}</p>
                        </div>
                        <div className="col-6 d-flex justify-content-between">
                            <p><strong>Salgysy:</strong> </p>
                            <p>{order.region || ''}, {order.city || ''}, {order.customer_street || order.address_details || ''}</p>

                        </div>

                    </div>
                    <div className="d-flex gap-2">
                        <div className="col-6 d-flex justify-content-between">
                            <p><strong>Töleg görnüşi:</strong> </p>
                            <p> {order.payment_method || 'N/A'}</p>
                        </div>

                        <div className="col-6 d-flex justify-content-between">
                            <p><strong>Döredilen senesi:</strong> </p>
                            <p> {new Date(order.created_at).toLocaleString("tr-TR")}</p>
                        </div>
                    </div>
                </div>

                <div className="table-responsive mb-3">
                    <table className="table table-bordered table-sm text-center align-middle">
                        <thead className="table-light">
                            <tr>
                                <th>Barkod</th>
                                <th>Ady</th>
                                <th>Sany</th>
                                <th>Bahasy</th>
                                <th>Arzanlaşyk</th>
                                <th>Jemi</th>
                            </tr>
                        </thead>
                        <tbody>
                            {order.items.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.product_barcode || item.barcode || "-"}</td>
                                    <td className="text-start">{item.item_title || item.product_name_tm}</td>
                                    <td>x{formatQuantity(item.item_quantity || item.quantity)}</td>
                                    <td>{Number(item.price || 0).toFixed(2)} m</td>
                                    <td> {item.discount && item.price > 0
                                        ? `${item.discount} m`
                                        : '-'} </td>
                                    <td>
                                        {(
                                            item.quantity * Number(item.discount || item.price || 0)
                                        ).toFixed(2)}{' '}
                                        m
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="row">
                    <div className="d-flex gap-2">
                        <div className="d-flex col-6 justify-content-between">
                            <p><strong>Eltip bermek hyzmaty:</strong> </p>
                            <p>{Number(order.delivery_price || 0).toFixed(2)} m</p>
                        </div>
                        <div className="col-6 d-flex justify-content-between ">
                            <p><strong>Harytlaryň jemi bahasy:</strong> </p>
                            <p>{Number(order.total_price || 0).toFixed(2)} m</p>


                        </div>
                    </div>
                    <div className=" col-12 d-flex justify-content-between">
                        <p className="fw-bold">
                            <strong>Jemi:</strong>{" "}

                        </p>

                        <p>{(Number(order.total_price || 0) + Number(order.delivery_price || 0)).toFixed(2)} m </p>
                    </div>
                </div>
            </div>
        </div>
    );
}
